const locales = window.TMW.Strings;
const shareArticleLocales = locales.article.share_article;

export default (element) => {
  const articleTrigger = element.querySelector('[data-article-share-link]');

  const copyToClipboard = () => {
    const url = window.location.href;
    const tooltip = document.querySelector('[data-article-share-tooltip]');

    const toolTipPopup = () => {
      tooltip.style.opacity = 1;
      setTimeout(() => {
        tooltip.style.opacity = 0;
        tooltip.removeAttribute('style');
      }, 1000);
    };

    navigator.clipboard
      .writeText(url)
      .then(() => {
        tooltip.innerHTML = shareArticleLocales.link_copied;
        toolTipPopup();
      })
      .catch(() => {
        tooltip.innerHTML = shareArticleLocales.link_copied_error;
        toolTipPopup();
      });
  };

  articleTrigger.addEventListener('click', copyToClipboard);
};
